/**
 * <ModalContent />
 *
 * @parent Modal
 * @stateless
 */
import React, { PropTypes } from 'react';
import Form from 'components/Form';
import locale from './locale';
import './Modal.scss';

class ModalContent extends React.Component {
  constructor(props){
    super(props)

  }

  render() {
    const {teacherData, onChange} = this.props;

    const schema = [
      {
        name: 'description',
        label: __('Description', locale),
        type: 'textarea',
        required: false,
      },
      {
        name: 'on_website',
        placeholder: __('Do you want to display this on website', locale),
        type: 'checkbox',
        required: false,
      },
    ];

    return (
      <div className='teacher-description-modal-content'>
        <Form
          onChange={onChange}
          schema={schema}
          formData={teacherData}
          formStyle='outline'
          getValidationRef={this.props.getValidationRef}
        />
      </div>
    )
  }
}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/template/Modals/TeacherDescription/ModalContent.js